import { QuestionHeading } from "features/AdminPanel/modules/DraggableTableWrapper/modules/QuestionHeading/QuestionHeading";
import { QuestionsActionField } from "../modules/QuestionsActionField/QuestionsActionField";
import React from "react";
import { DragIndicator } from "features/AdminPanel/modules/DraggableTableWrapper/modules/DragIndicator/DragIndicator";
import { questions_list_keys } from "./ContactFormList.constants";
import { QuestionMandatoryCheckbox } from "../modules/QuestionMandatoryCheckbox/QuestionMandatoryCheckbox";

export const contactFormColumnConfig = ({
  handleDeleteQuestion,
  openEditQuestionmodal,
  handleToggleQuestionMandatory,
}) => [
  {
    field: questions_list_keys.question.field,
    headerName: questions_list_keys.question.headerName,
    valueFormatter: (record) => <QuestionHeading record={record} />,
  },
  {
    field: questions_list_keys.is_mandatory.headerName,
    headerName: questions_list_keys.is_mandatory.headerName,
    valueFormatter: (record) => (
      <QuestionMandatoryCheckbox
        handleToggleQuestionMandatory={handleToggleQuestionMandatory}
        record={record}
      />
    ),
  },
  {
    field: "",
    headerName: "Actions",
    valueFormatter: (record) => (
      <QuestionsActionField
        record={record}
        handleDeleteQuestion={handleDeleteQuestion}
        openEditQuestionmodal={openEditQuestionmodal}
      />
    ),
  },
  {
    field: "",
    valueFormatter: (record) => (
      <DragIndicator disabled={record.isDragDisabled} />
    ),
  },
];
